import React, { useState, useContext, useEffect } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import Axios from 'axios';

import { UserContext, SnackbarContext, EngInfoContext } from './userContext';

const key = 'dqweqwe123y97qhduiasd$@^!*#&bjasdja&^&@!#';

/* ─────────── inline icons ─────────── */
const I = {
  Phone: ({ className }) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden>
      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6A19.79 19.79 0 0 1 2.12 4.18 2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.96.37 1.9.72 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.91.35 1.85.59 2.81.72a2 2 0 0 1 1.72 2z" />
    </svg>
  ),
  Lock: ({ className }) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden>
      <rect x="3" y="11" width="18" height="11" rx="2" />
      <path d="M7 11V7a5 5 0 0 1 10 0v4" />
    </svg>
  ),
  Eye: ({ className }) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden>
      <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7z" />
      <circle cx="12" cy="12" r="3" />
    </svg>
  ),
  EyeOff: ({ className }) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden>
      <path d="M17.94 17.94A10.94 10.94 0 0 1 12 19c-7 0-10-7-10-7a18.45 18.45 0 0 1 5.06-5.94" />
      <path d="M9.9 4.24A10.94 10.94 0 0 1 12 4c7 0 10 7 10 7a18.6 18.6 0 0 1-2.16 3.19" />
      <line x1="1" y1="1" x2="23" y2="23" />
      <path d="M14.12 14.12a3 3 0 0 1-4.24-4.24" />
    </svg>
  ),
  ArrowRight: ({ className }) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden>
      <path d="M5 12h14M13 5l7 7-7 7" />
    </svg>
  ),
  Close: ({ className }) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden>
      <path d="M18 6 6 18M6 6l12 12" />
    </svg>
  ),
};

/* ─────────── Field ─────────── */
function Field({ label, type, value, onChange, error, errorMsg, icon, rightSlot, autoFocus, autoComplete, inputMode, maxLength, required, placeholder }) {
  return (
    <div className="w-full">
      <label className="mb-1.5 block text-[10.5px] font-bold uppercase tracking-[0.14em] text-fg-tertiary">
        {label}
        {required && <span className="ml-1 text-amber">*</span>}
      </label>
      <div
        className={`
          relative flex h-11 items-center gap-2 rounded-lg px-3
          bg-surface-overlay/70
          border
          transition-[border-color,background-color,box-shadow] duration-200 ease-out-soft
          focus-within:bg-surface-overlay
          focus-within:shadow-[0_0_0_3px_rgba(251,191,36,0.18)]
          ${error
            ? 'border-red-400/55 focus-within:border-red-400'
            : 'border-border-subtle hover:border-amber/40 focus-within:border-amber'}
        `}
      >
        {icon && (
          <span className={`shrink-0 ${error ? 'text-red-400' : 'text-amber/70'}`}>{icon}</span>
        )}
        <input
          type={type}
          value={value}
          onChange={onChange}
          autoFocus={autoFocus}
          autoComplete={autoComplete}
          inputMode={inputMode}
          maxLength={maxLength}
          placeholder={placeholder}
          className="w-full bg-transparent text-[14px] font-medium text-fg-primary placeholder:text-fg-muted outline-none border-0 p-0 leading-none"
        />
        {rightSlot && <div className="shrink-0 -mr-1">{rightSlot}</div>}
      </div>
      <div className="mt-1.5 min-h-[14px] text-[11px] leading-[1.4]">
        {error && <span className="text-red-400">{errorMsg}</span>}
      </div>
    </div>
  );
}

export const NewLoginForm = (props) => {
  const { setUser } = useContext(UserContext);
  const { setSnack } = useContext(SnackbarContext);
  const { setEngInfoList } = useContext(EngInfoContext);

  const [num, setNum] = useState('');
  const [pass, setPass] = useState('');
  const [showPass, setShowPass] = useState(false);
  const [error, setError] = useState(0);

  const open = !!props.open;
  const strict = !!props.strict;

  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => {
      if (strict) return;
      if (e.key === 'Escape') props.closeform && props.closeform();
    };
    document.addEventListener('keydown', onKey);
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = prev;
    };
  }, [open, props, strict]);

  const getEngInfodata = async (tkn, uid) => {
    try {
      const res = await Axios.post('/new_apis/get_bookmarks', { user_id: uid }, { headers: { tkn } });
      if (res.data.status === 1) setEngInfoList(res.data.data.map((d) => d.id));
    } catch { /* noop */ }
  };

  const submit = (e) => {
    if (e && e.preventDefault) e.preventDefault();
    setError(0);
    if (num.length !== 10) {
      setError(1);
      setSnack({ message: 'Enter a valid 10-digit mobile number.', type: 'error', open: true });
      return;
    }
    if (pass.length < 3) {
      setError(2);
      setSnack({ message: 'Enter your password.', type: 'error', open: true });
      return;
    }
    props.closeform();
    props.showload();
    Axios.post('/new_apis/new_login', { num, pass }, { headers: { key } }).then((res) => {
      if (res.data.status) {
        setUser(res.data.user_data);
        props.hideload();
        props.closeform();
        localStorage.setItem('estkn', res.data.token);
        getEngInfodata(res.data.token, res.data.user_data.user_id);
        setSnack({ message: res.data.msg, type: 'success', open: true, direction: 'left' });
      } else {
        props.hideload();
        if (props.openloginform) props.openloginform();
        setSnack({ message: res.data.msg, type: 'error', open: true });
      }
    }).catch(() => {
      props.hideload();
      setSnack({ message: 'Network error. Please try again.', type: 'error', open: true });
    });
  };

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-[1300] flex items-center justify-center p-4"
      role="dialog"
      aria-modal="true"
      aria-labelledby="inline-login-title"
    >
      {strict ? (
        <div aria-hidden className="absolute inset-0 bg-black/82 backdrop-blur-md animate-[fadeIn_180ms_ease-out]" />
      ) : (
        <button
          type="button"
          aria-label="Close"
          onClick={props.closeform}
          className="absolute inset-0 bg-black/72 backdrop-blur-md animate-[fadeIn_180ms_ease-out]"
        />
      )}
      <div
        className={`
          relative w-full max-w-[420px]
          rounded-2xl bg-surface-paper
          shadow-dialog
          animate-[fadeIn_220ms_ease-out]
          max-h-[90vh] overflow-hidden flex flex-col
          ${strict
            ? 'border-2 border-amber/45 shadow-[0_24px_64px_-12px_rgba(0,0,0,0.85),0_0_72px_-12px_rgba(251,191,36,0.32)]'
            : 'border border-amber/24'}
        `}
      >
        <span aria-hidden className="pointer-events-none absolute inset-x-6 top-0 h-px bg-gradient-to-r from-transparent via-amber/60 to-transparent" />

        {/* Header */}
        <div className="relative flex items-start justify-between gap-3 px-5 pt-5 pb-2">
          <div className="min-w-0">
            <div className="mb-1 inline-flex items-center gap-1.5">
              <span aria-hidden className="relative flex h-1.5 w-1.5">
                <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-amber opacity-60" />
                <span className="relative inline-flex h-1.5 w-1.5 rounded-full bg-amber" />
              </span>
              <span className="text-[10px] font-bold uppercase tracking-[0.18em] text-amber">
                {strict ? 'Sign in required' : 'Welcome back'}
              </span>
            </div>
            <h2 id="inline-login-title" className="text-[20px] font-bold tracking-[-0.018em] text-fg-primary">
              {strict ? (props.strictTitle || 'Sign in to continue') : 'Sign in'}
            </h2>
            <p className="mt-1 text-[12.5px] text-fg-secondary">
              {strict
                ? (props.strictMessage || 'You need an ESAY account to access this page.')
                : 'Log in to continue with ESAY.'}
            </p>
          </div>
          {!strict && (
            <button
              type="button"
              onClick={props.closeform}
              aria-label="Close"
              className="
                inline-flex h-8 w-8 items-center justify-center rounded-full shrink-0
                text-fg-tertiary
                transition-[background-color,color] duration-200
                hover:bg-surface-overlay hover:text-amber
              "
            >
              <I.Close className="h-4 w-4" />
            </button>
          )}
        </div>

        {/* Body */}
        <form onSubmit={submit} noValidate className="flex flex-col gap-2 px-5 pb-1 pt-1">
          <Field
            label="Mobile number"
            type="tel"
            value={num}
            onChange={(e) => setNum(e.target.value.replace(/\D/g, '').slice(0, 10))}
            error={error === 1}
            errorMsg="Enter a valid 10-digit mobile number."
            required
            autoFocus
            autoComplete="tel"
            inputMode="numeric"
            maxLength={10}
            icon={<I.Phone className="h-4 w-4" />}
          />
          <Field
            label="Password"
            type={showPass ? 'text' : 'password'}
            value={pass}
            onChange={(e) => setPass(e.target.value)}
            error={error === 2}
            errorMsg="Please enter your password."
            required
            autoComplete="current-password"
            icon={<I.Lock className="h-4 w-4" />}
            rightSlot={(
              <button
                type="button"
                onClick={() => setShowPass((v) => !v)}
                aria-label={showPass ? 'Hide password' : 'Show password'}
                className="inline-flex h-7 w-7 items-center justify-center rounded-md text-fg-tertiary transition-colors duration-200 hover:bg-surface-overlay hover:text-amber"
              >
                {showPass ? <I.EyeOff className="h-4 w-4" /> : <I.Eye className="h-4 w-4" />}
              </button>
            )}
          />
        </form>

        {/* Signup link */}
        <div className="px-5 pb-3 text-center text-[12.5px] text-fg-secondary">
          New to ESAY?{' '}
          <RouterLink to="/signup" onClick={strict ? undefined : props.closeform} className="font-bold text-amber hover:text-amber-light underline-offset-2 hover:underline">
            Create an account
          </RouterLink>
        </div>

        {/* Footer */}
        <div className={`flex items-center gap-2 border-t border-border-subtle px-5 py-3 bg-surface-overlay/30 ${strict ? 'justify-center sm:justify-end' : 'justify-end'}`}>
          {!strict && (
            <button
              type="button"
              onClick={props.closeform}
              className="
                inline-flex h-10 items-center justify-center gap-1 rounded-lg px-4
                text-[12px] font-bold uppercase tracking-[0.08em]
                border border-border-subtle text-fg-secondary
                transition-[background-color,border-color,color] duration-200
                hover:bg-surface-overlay hover:text-fg-primary hover:border-amber/30
              "
            >
              Cancel
            </button>
          )}
          <button
            type="button"
            onClick={submit}
            className={`
              group inline-flex h-10 items-center justify-center gap-1.5 rounded-lg px-5
              text-[12px] font-bold uppercase tracking-[0.1em]
              bg-amber text-ink
              transition-[background-color,box-shadow,transform] duration-200 ease-out-soft
              hover:bg-amber-light
              hover:shadow-[0_0_0_3px_rgba(251,191,36,0.28),0_8px_22px_-8px_rgba(251,191,36,0.5)]
              active:scale-[0.98]
              ${strict ? 'flex-1 sm:flex-initial' : ''}
            `}
          >
            Sign in
            <I.ArrowRight className="h-3.5 w-3.5 transition-transform duration-200 group-hover:translate-x-0.5" />
          </button>
        </div>
      </div>
    </div>
  );
};
